import { useState } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '../../../../../redux/store';
import { Grid } from '@mui/material';
import { Box } from '@mui/material';

import { useComplianceTermsForm } from '../hook';
import { ComplianceTermsData } from './data';
import { ComplianceTermsHistorical } from '../historical';

import FormView from '../../../../components/views/formView';
import LoadingButtonGeneral from '../../../../components/general/buttons/loadingButtonGeneral';
import ActionButtonGroup from '../../../../components/general/buttons/actionButtonGroup';
import { isTrainerOrQuality } from '../../../../../shared/types/profiles';
import {
    COMPLIANCE_TERMS_EDIT,
    COMPLIANCE_TERMS_NEW,
    COMPLIANCE_TERMS,
    COMPLIANCE_TERMS_DETAIL,
} from '../../../../../routes/paths';

export const ComplianceTermsForm = () => {
    const [showHistorical, setShowHistorical] = useState(false);

    const {
        complianceTerms,
        loading,
        handleSubmit,
        handleCleanAndBack,
        setformikComplianceTermsData,
        complianceTermsHistorical,
    } = useComplianceTermsForm(showHistorical);

    const { logUser } = useSelector((state: RootState) => state.general);
    const { type } = logUser || {};

    const toggleHistorical = () => {
        setShowHistorical(!showHistorical);
    };

    const showActionButtons =
        complianceTerms && complianceTerms?.id ? true : false;

    return (
        <>
            <FormView
                title={
                    complianceTerms && complianceTerms.id
                        ? 'Editar Cumplimiento de términos PQR'
                        : 'Crear Cumplimiento de términos PQR'
                }
                additionalButtons={
                    <ActionButtonGroup
                        id={complianceTerms?.id || ''}
                        buttonCreate={{
                            show:
                                showActionButtons && !isTrainerOrQuality(type),
                            route: COMPLIANCE_TERMS_NEW,
                        }}
                        buttonSearch={{
                            show: true,
                            route: COMPLIANCE_TERMS,
                        }}
                        buttonUpdate={{
                            show:
                                !showActionButtons && !isTrainerOrQuality(type),
                            route: COMPLIANCE_TERMS_EDIT,
                        }}
                        buttonView={{
                            show: true,
                            route: COMPLIANCE_TERMS_DETAIL,
                        }}
                        buttonLog={{
                            show: showActionButtons,
                        }}
                        onHistoricalShow={toggleHistorical}
                    />
                }
            />
            {showHistorical && (
                <Box sx={{ marginTop: 2 }}>
                    <ComplianceTermsHistorical
                        historical={complianceTermsHistorical ?? []}
                        showHistorical={true}
                    />
                </Box>
            )}
            <ComplianceTermsData
                data={complianceTerms}
                onChangeFormik={(formik) =>
                    setformikComplianceTermsData(formik)
                }
            />
            <Grid item xs={12} mt={5} mb={10}>
                <LoadingButtonGeneral
                    disabled={loading}
                    loading={loading}
                    title="Guardar"
                    sx={{ mr: 1 }}
                    onClick={handleSubmit}
                />
                <LoadingButtonGeneral
                    disabled={loading}
                    title="Volver"
                    variant="outlined"
                    onClick={handleCleanAndBack}
                />
            </Grid>
        </>
    );
};
